export const FILTER_SORT_APPLICATION_FAILED =
  'Could not apply selection!, please retry.';

export const NETWORK_ERROR = 'Network Error!';
export const CONV_SEARCH_ERROR =
  'Something went wrong. Please try again later.';
